/* Prophète — comportements de la nouvelle boutique (layout pht). */
(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];
  const routes = () => window.PHT?.routes || { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };

  const onLoaded = (img) => {
    const done = () => img.classList.add('is-loaded');
    img.complete ? done() : img.addEventListener('load', done, { once: true });
  };

  /* ---------- Rotation (barre d'annonce, hero) ---------- */
  function rotator(controls, items, { delay, onChange }) {
    if (!items.length) return;
    let index = 0;
    let timer;
    const restart = () => {
      clearInterval(timer);
      if (items.length > 1) timer = setInterval(() => show(index + 1), delay);
    };
    const show = (i) => {
      items[index].classList.remove('is-active');
      index = (i + items.length) % items.length;
      items[index].classList.add('is-active');
      onChange?.(index);
      restart();
    };
    $('[data-prev]', controls)?.addEventListener('click', () => show(index - 1));
    $('[data-next]', controls)?.addEventListener('click', () => show(index + 1));
    onChange?.(0);
    restart();
  }

  const announce = $('[data-rotator]');
  if (announce) rotator(announce, $$('.announce__msg', announce), { delay: 4000 });

  const hero = $('[data-slider]');
  if (hero) {
    const slides = $$('.hero__slide', hero);
    const pad = (n) => String(n).padStart(2, '0');
    rotator(hero, slides, {
      delay: 6000,
      onChange(i) {
        const current = $('[data-current]', hero);
        if (current) current.textContent = pad(i + 1);
        const bar = $('.hero__progress i', hero);
        if (bar) bar.style.width = `${((i + 1) / slides.length) * 100}%`;
      },
    });
  }

  /* ---------- Menu et recherche ---------- */
  const menu = $('#pht-menu');
  const menuBtn = $('[data-menu-open]');
  const openMenu = () => {
    menu.hidden = false;
    menuBtn.setAttribute('aria-expanded', 'true');
    document.body.classList.add('is-locked');
    $('.menu__list a, [data-menu-close]', menu)?.focus();
  };
  const closeMenu = () => {
    menu.hidden = true;
    menuBtn.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('is-locked');
    menuBtn.focus();
  };
  menuBtn?.addEventListener('click', openMenu);
  $$('[data-menu-close]', menu || document).forEach((el) => el.addEventListener('click', closeMenu));

  const searchBtn = $('[data-search-toggle]');
  const searchBar = $('#pht-search');
  searchBtn?.addEventListener('click', () => {
    searchBar.hidden = !searchBar.hidden;
    searchBtn.setAttribute('aria-expanded', String(!searchBar.hidden));
    if (!searchBar.hidden) $('input[name="q"]', searchBar).focus();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (menu && !menu.hidden) closeMenu();
    if (searchBar && !searchBar.hidden) { searchBar.hidden = true; searchBtn.focus(); }
    const sheet = $('[data-sheet]:not([hidden])');
    if (sheet) closeSheet(sheet);
  });

  /* ---------- Panier : compteur + ajout ---------- */
  function setCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
      el.closest('a')?.setAttribute('aria-label', `Panier (${count})`);
    });
  }

  // Petit panier qui vole du bouton jusqu'à l'icône panier du header
  function flyToCart(fromEl) {
    const target = $('.icon-btn--cart');
    if (!fromEl || !target) return Promise.resolve();
    const bump = () => {
      target.classList.remove('is-bump');
      void target.offsetWidth; // relance l'animation si on ajoute plusieurs fois
      target.classList.add('is-bump');
    };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !document.body.animate) {
      bump();
      return Promise.resolve();
    }
    const a = fromEl.getBoundingClientRect();
    const b = target.getBoundingClientRect();
    const size = 44;
    const start = { x: a.left + a.width / 2 - size / 2, y: a.top + a.height / 2 - size / 2 };
    const end = { x: b.left + b.width / 2 - size / 2, y: b.top + b.height / 2 - size / 2 };
    const dx = end.x - start.x;
    const dy = end.y - start.y;
    // Point de contrôle : léger envol puis glissé vers le panier, sans jamais sortir de l'écran
    const cx = dx * 0.75;
    const cy = Math.max(end.y, start.y - 70) - start.y;

    const bag = document.createElement('div');
    bag.className = 'fly-bag';
    bag.setAttribute('aria-hidden', 'true');
    bag.innerHTML = '<svg><use href="#i-bag"/></svg>';
    bag.style.left = `${start.x}px`;
    bag.style.top = `${start.y}px`;
    document.body.append(bag);

    const at = (t, scale, opacity) => {
      // courbe de Bézier quadratique : départ -> point de contrôle -> panier
      const x = 2 * (1 - t) * t * cx + t * t * dx;
      const y = 2 * (1 - t) * t * cy + t * t * dy;
      return { transform: `translate(${x}px, ${y}px) scale(${scale})`, opacity, offset: t };
    };
    const anim = bag.animate(
      [at(0, 0.6, 0), at(0.12, 1.1, 1), at(0.3, 1, 1), at(0.55, 0.85, 1), at(0.8, 0.6, 1), at(1, 0.35, 0.9)],
      { duration: 850, easing: 'cubic-bezier(.45,.05,.35,1)', fill: 'forwards' },
    );
    return anim.finished.then(() => {
      bag.remove();
      bump();
    });
  }

  async function addToCart(formData, fromEl) {
    const res = await fetch(`${routes().cartAdd}.js`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || "Impossible d'ajouter cet article.");
    const [cart] = await Promise.all([
      fetch(`${routes().cart}.js`).then((r) => r.json()),
      flyToCart(fromEl),
    ]);
    setCount(cart.item_count);
    return data;
  }

  // Bouton panier des cartes de la page d'accueil
  $$('form[data-quick-add]').forEach((form) =>
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = $('button', form);
      btn.disabled = true;
      try {
        await addToCart(new FormData(form), btn);
        btn.classList.add('is-added');
        setTimeout(() => btn.classList.remove('is-added'), 1500);
      } catch (err) {
        alert(err.message);
      } finally {
        btn.disabled = false;
      }
    }));

  /* ---------- Catalogue : filtres et affichage ---------- */
  function openSheet(sheet) { sheet.hidden = false; document.body.classList.add('is-locked'); }
  function closeSheet(sheet) { sheet.hidden = true; document.body.classList.remove('is-locked'); }
  $$('[data-open-filters]').forEach((btn) => {
    const sheet = document.getElementById(btn.getAttribute('aria-controls')) || $('[data-sheet]');
    btn.addEventListener('click', () => openSheet(sheet));
    $$('[data-close-filters]', sheet).forEach((el) => el.addEventListener('click', () => closeSheet(sheet)));
  });

  const grid = $('[data-grid]');
  const VIEW_KEY = 'pht-view';
  const setView = (cols) => {
    if (!grid) return;
    grid.dataset.cols = cols;
    $$('.view-btn').forEach((b) => {
      const on = b.dataset.view === cols;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on);
    });
  };
  $$('.view-btn').forEach((btn) =>
    btn.addEventListener('click', () => {
      setView(btn.dataset.view);
      try { localStorage.setItem(VIEW_KEY, btn.dataset.view); } catch { /* stockage indisponible */ }
    }));
  try { const saved = localStorage.getItem(VIEW_KEY); if (saved) setView(saved); } catch { /* stockage indisponible */ }

  $('.chip.is-active')?.scrollIntoView({ block: 'nearest', inline: 'center' });
  $$('.item__media img, .gallery__slide img').forEach(onLoaded);

  /* ---------- Fiche produit ---------- */
  const pdp = $('[data-product]');
  if (pdp) {
    const data = JSON.parse($('[data-product-json]', pdp).textContent);
    const track = $('[data-track]', pdp);
    const thumbs = $$('.thumb', pdp);
    const count = $('[data-gallery-count]', pdp);
    let current = Number(track.dataset.start) || 0;

    const setActive = (i) => {
      current = i;
      thumbs.forEach((t, n) => t.classList.toggle('is-active', n === i));
      if (count) count.textContent = `${i + 1} / ${data.images.length}`;
    };
    const goTo = (i, smooth = true) => {
      track.scrollTo({ left: i * track.clientWidth, behavior: smooth ? 'smooth' : 'instant' });
      setActive(i);
    };
    thumbs.forEach((t) => t.addEventListener('click', () => goTo(Number(t.dataset.thumb))));
    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== current) setActive(i);
      });
    });
    if (current) requestAnimationFrame(() => goTo(current, false));

    const form = $('[data-product-form]', pdp);
    const idInput = $('[data-variant-id]', form);
    const addBtn = $('[data-add]', form);
    const buy = $('[data-buy]', form);
    const feedback = $('[data-feedback]', form);
    const qty = $('[data-qty-input]', form);

    const selected = () => $$('.variants', form).map((group) => $('.opt.is-selected', group)?.dataset.value);
    const findVariant = (opts) => data.variants.find((v) => v.options.every((o, i) => o === opts[i]));

    // Grise les valeurs dont la combinaison avec les autres choix est épuisée
    const markAvailability = () => {
      const opts = selected();
      $$('.variants', form).forEach((group, gi) => {
        $$('.opt', group).forEach((btn) => {
          const test = [...opts];
          test[gi] = btn.dataset.value;
          const v = findVariant(test);
          btn.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    };

    const applyVariant = (moveGallery) => {
      const v = findVariant(selected());
      $$('.variants', form).forEach((group, gi) => {
        const label = $(`[data-option-value="${gi}"]`, form);
        if (label) label.textContent = selected()[gi] || '';
      });
      markAvailability();
      if (!v) {
        addBtn.disabled = true;
        addBtn.textContent = 'Indisponible';
        buy.classList.add('is-soldout');
        return;
      }
      idInput.value = v.id;
      $('[data-price]', pdp).textContent = v.price;
      const stock = $('[data-stock]', pdp);
      stock.textContent = v.available ? 'En stock' : 'Épuisé';
      stock.classList.toggle('is-out', !v.available);
      buy.classList.toggle('is-soldout', !v.available);
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'Ajouter au panier' : 'Épuisé';
      const url = new URL(location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState(null, '', url);
      if (moveGallery && v.media) {
        const i = data.images.indexOf(v.media);
        if (i >= 0) goTo(i);
      }
    };

    $$('.opt', form).forEach((btn) =>
      btn.addEventListener('click', () => {
        const group = btn.closest('.variants__list');
        $$('.opt', group).forEach((b) => {
          b.classList.toggle('is-selected', b === btn);
          b.setAttribute('aria-checked', b === btn);
        });
        applyVariant(true);
      }));
    markAvailability();

    $$('[data-qty-step]', form).forEach((btn) =>
      btn.addEventListener('click', () => {
        qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + Number(btn.dataset.qtyStep));
      }));
    qty.addEventListener('change', () => { qty.value = Math.max(1, parseInt(qty.value, 10) || 1); });

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (addBtn.disabled) return;
      addBtn.disabled = true;
      feedback.hidden = true;
      try {
        await addToCart(new FormData(form), addBtn);
        addBtn.textContent = 'Ajouté au panier';
        addBtn.classList.add('is-added');
        feedback.innerHTML = `Article ajouté · <a href="${routes().cart}">Voir le panier</a>`;
        feedback.hidden = false;
        setTimeout(() => {
          addBtn.textContent = 'Ajouter au panier';
          addBtn.classList.remove('is-added');
          addBtn.disabled = false;
        }, 1800);
      } catch (err) {
        feedback.textContent = err.message;
        feedback.hidden = false;
        addBtn.disabled = false;
      }
    });
  }

  /* ---------- Vous aimerez aussi ---------- */
  const recos = $('[data-recos]');
  if (recos) {
    fetch(recos.dataset.url)
      .then((r) => r.text())
      .then((html) => {
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recos]');
        if (fresh && fresh.querySelector('.item')) {
          recos.innerHTML = fresh.innerHTML;
          $$('.item__media img', recos).forEach(onLoaded);
        }
      })
      .catch(() => { /* on garde la sélection de secours */ });
  }

  /* ---------- Avis clients : carrousel ---------- */
  $$('[data-reviews]').forEach((root) => {
    const track = $('[data-reviews-track]', root);
    if (!track) return;
    const cards = $$('.review', track);
    const prev = $('[data-reviews-prev]', root);
    const next = $('[data-reviews-next]', root);
    const count = $('[data-reviews-count]', root);
    const step = () => (cards[1] ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth);
    const index = () => Math.round(track.scrollLeft / step());
    const update = () => {
      const i = Math.min(index(), cards.length - 1);
      if (count) count.textContent = `${i + 1} / ${cards.length}`;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    };
    prev?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    let raf;
    track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
    update();
  });

  /* ---------- Page panier ---------- */
  document.addEventListener('click', async (e) => {
    const link = e.target.closest('[data-cart] [data-change]');
    if (!link) return;
    e.preventDefault();
    const root = link.closest('[data-cart]');
    const line = Number(link.closest('[data-line]').dataset.line);
    const quantity = Number(link.dataset.change);
    const row = link.closest('[data-line]');
    if (quantity === 0) row.classList.add('is-leaving');
    root.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(`${routes().cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity }),
      });
      const cart = await res.json();
      if (!res.ok) throw new Error(cart.description || cart.message || 'Mise à jour impossible.');
      setCount(cart.item_count);
      const html = await fetch(`${routes().cart}?section_id=${root.dataset.sectionId}`).then((r) => r.text());
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart]');
      if (fresh) root.replaceWith(fresh);
    } catch (err) {
      row.classList.remove('is-leaving');
      const box = $('[data-cart-error]', root);
      if (box) { box.textContent = err.message; box.hidden = false; }
    } finally {
      root.removeAttribute('aria-busy');
    }
  });
})();
